import { AnalyticsController } from 'analytics/analytics-controller';

/**
 * Tracks an analytics event.
 * @deprecated Use {@link AnalyticsController.trackEvent} instead.
 */
export function trackEvent(event: string, category = 'All', label?: string, value?: number) {
  AnalyticsController.trackEvent(event, category, label, value);
}